import { Event, EventEntry } from "../../models"
import { getFormattedEntryClassList } from "../eventClassEntry/FormattedEventEntryClasses";


export interface FormattedEventClassData {
    id: string; // The id of the entry
    eventEntry: EventEntry; // The entry itself
    totalAmount: number;
}

function classFeeTotalFromFormattedList(dataResult: { isSuccess?: boolean; result?: { totalEntryFees?: number } | null } | null | undefined): number {
    if (!dataResult?.isSuccess || !dataResult.result) return 0;
    const total = dataResult.result.totalEntryFees;
    return typeof total === "number" && Number.isFinite(total) ? total : 0;
}

export const getFormattedEventClassData = async (_event: Event, currentEventEntries: EventEntry[]): Promise<FormattedEventClassData[]> => {
    const formattedEntries = await Promise.all(
        (currentEventEntries ?? []).map(async (current): Promise<FormattedEventClassData> => {
            try {
                const dataResult = await getFormattedEntryClassList(current, false);
                return {
                    id: current.id,
                    eventEntry: current,
                    totalAmount: classFeeTotalFromFormattedList(dataResult),
                };
            } catch (error) {
                console.error("Could not format class fee data for entry:", current.id, error);
                return {
                    id: current.id,
                    eventEntry: current,
                    totalAmount: 0,
                };
            }
        })
    );
    return formattedEntries;
};
